/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Refresh_Failed_ToastInputs */

const en_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to refresh folders`)
};

const fr_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de l'actualisation des dossiers`)
};

const de_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordner konnten nicht aktualisiert werden`)
};

const it_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile aggiornare le cartelle`)
};

const ru_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось обновить папки.`)
};

const es_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron actualizar las carpetas`)
};

const zh_cn2_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新文件夹失败`)
};

const ja_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダを更新できませんでした`)
};

const hi_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर रीफ़्रेश करने में विफल`)
};

const pt_pt2_explorer_nav_refresh_failed_toast = /** @type {(inputs: Explorer_Nav_Refresh_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar as pastas`)
};

/**
* | output |
* | --- |
* | "Failed to refresh folders" |
*
* @param {Explorer_Nav_Refresh_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_refresh_failed_toast = /** @type {((inputs?: Explorer_Nav_Refresh_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Refresh_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_refresh_failed_toast(inputs)
	if (locale === "de") return de_explorer_nav_refresh_failed_toast(inputs)
	if (locale === "it") return it_explorer_nav_refresh_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_nav_refresh_failed_toast(inputs)
	if (locale === "es") return es_explorer_nav_refresh_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_refresh_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_nav_refresh_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_nav_refresh_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_refresh_failed_toast(inputs)
	return en_explorer_nav_refresh_failed_toast(inputs)
});